import { Footer, FooterActions, FooterInfo, FooterLink, FooterText } from "common-ui-components";
import { selectConfig, selectSession } from "../redux/selectors";
import { getSession } from "../redux/Slice/sessionSlice";
import { useDispatch, useSelector } from "react-redux";
import { copyToClipboard } from "../utils/utils";
import ARCA from "../assets/images/ARCA.png";

const CustomFooter = () => {
  const year = new Date().getFullYear();
  const session = useSelector(selectSession);
  const dispatch = useDispatch();
  const { language: { footer: text } } = useSelector(selectConfig);

  const handleClick = () => {
    dispatch(getSession());
    copyToClipboard(session.data);
  };

  return (
    <div>
      <Footer className='main-footer'>
        <FooterInfo>

          <FooterText onClick={handleClick} className='main-footer-text-bottom'>
            {text.legalInfo} {' '}
          </FooterText>
          <FooterLink href='https://autogestion.produccion.gob.ar/consumidores' target='_blank'>
            {text.customerDefense}
          </FooterLink>
        </FooterInfo>
      </Footer>
      <Footer className='main-footer'>
        <FooterInfo>
          <FooterText onClick={handleClick} className='main-footer-text'>
            {text.rightsReserved} {year}
          </FooterText>
          <FooterLink href='https://www.claro.com.ar/personas/legal-y-regulatorio' target='_blank'>
            {text.legal}
          </FooterLink>
          <br />
        </FooterInfo>
        <FooterActions>
          <FooterLink href={text.qrLink} target="_F960AFIPInfo">
            <img src="https://www.afip.gob.ar/images/f960/DATAWEB.jpg" width="29" height="39" alt="Data fiscal - QR" />
          </FooterLink>
        </FooterActions>
      </Footer>
    </div>
  );
};

export default CustomFooter;